export const zoneAdapter = (zone) => {
  return {
    id: zone.id,
    name: zone.name,
  };
};
